import { defineAction } from '~/prix'
import userSelfAction from './userSelf.action.json' with { type: 'json' }
import { z } from 'zod'

const userSelfDefinition = defineAction({
  ...userSelfAction,

  input: z.object({}),
  output: z.object({
    userProfile: z.any(),
  }),
  cache: () => {
    return {
      back: {},
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 30 * 3, // 3 months
        expirationMsForUpdate: 1000 * 60 * 60 * 2, // 2 hours
      },
    }
  },
})

export default userSelfDefinition
